import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Check, ShieldCheck, BadgePoundSterling, Lock, Quote } from "lucide-react";
import { api, gbp } from "../lib/api";
import { useSeo, Loader } from "../components/kit";

export default function About() {
  const [p, setP] = useState(null);
  const [plans, setPlans] = useState([]);
  useEffect(() => { api.get("/cms/about").then((r) => setP(r.data)); api.get("/plans").then((r) => setPlans(r.data)); }, []);
  useSeo(p?.title, p?.meta_description);
  if (!p) return <Loader />;
  const icons = [ShieldCheck, BadgePoundSterling, Lock];
  return (
    <div data-testid="about-page">
      <section className="bg-[#FAF7EE]"><div className="container-x py-14 text-center"><h1 className="text-4xl sm:text-5xl font-extrabold text-slate-900" data-testid="about-title">{p.hero_title}</h1></div></section>

      <section className="container-x py-16 lg:py-24 grid lg:grid-cols-2 gap-12 items-center">
        <div className="grid grid-cols-2 gap-4">
          <div className="space-y-4 pt-10"><img src="/brand/about1.webp" alt="" className="rounded-2xl w-full" /><img src="/brand/about2.webp" alt="" className="rounded-2xl w-full" /></div>
          <div className="space-y-4"><img src="/brand/about4.webp" alt="" className="rounded-2xl w-full" /><img src="/brand/about3.webp" alt="" className="rounded-2xl w-full" /></div>
        </div>
        <div>
          <h2 className="h2">{p.intro_heading}</h2>
          <p className="text-slate-600 mt-5 leading-relaxed">{p.intro_body}</p>
          <p className="text-slate-800 font-semibold mt-6">{p.mission_intro}</p>
          <ul className="mt-3 space-y-3">{(p.mission || []).map((m) => <li key={m} className="flex gap-3 text-slate-600"><span className="w-6 h-6 rounded-full bg-[#FFF1EE] text-[#FF8267] grid place-items-center shrink-0"><Check size={14} /></span>{m}</li>)}</ul>
          <Link to="/register" className="btn-coral mt-8" data-testid="about-get-started-btn">Get Started</Link>
        </div>
      </section>

      <section className="bg-[#374B5C] text-white"><div className="container-x py-16 lg:py-24 grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold">{p.features_heading}</h2>
          <div className="mt-8 space-y-6">{(p.features || []).map((f, i) => { const I = icons[i % 3]; return (
            <div key={f.heading} className="flex gap-4"><span className="w-12 h-12 rounded-2xl bg-white/10 text-[#FF8267] grid place-items-center shrink-0"><I size={22} /></span><div><h3 className="font-bold text-lg">{f.heading}</h3><p className="text-slate-300 text-sm mt-1">{f.body}</p></div></div>); })}</div>
        </div>
        <img src="/brand/aboutus_seller.webp" alt="" className="w-full max-w-md mx-auto" loading="lazy" />
      </div></section>

      <section className="container-x py-16 lg:py-24">
        <div className="text-center mb-10"><h2 className="h2">Testimonials</h2><p className="muted mt-2">A selection of reviews from happy customers</p></div>
        <div className="grid md:grid-cols-2 gap-5 stagger">{(p.testimonials || []).map((t) => (
          <figure key={t.name} className="card p-6" data-testid="about-testimonial">
            <Quote className="text-[#FF8267]" size={28} />
            <blockquote className="text-slate-700 mt-3 leading-relaxed">"{t.text}"</blockquote>
            <figcaption className="flex items-center gap-3 mt-5">{t.photo && <img src={t.photo} alt={t.name} className="w-12 h-12 rounded-full object-cover" loading="lazy" />}<div><div className="font-bold text-slate-900">{t.name}</div><div className="text-xs muted">{t.job}</div></div></figcaption>
          </figure>))}</div>
      </section>

      <section className="bg-[#FAF7EE]"><div className="container-x py-16 lg:py-24 grid lg:grid-cols-2 gap-12 items-center">
        <img src="/brand/home_thumbs_up.webp" alt="" className="w-full max-w-md mx-auto" loading="lazy" />
        <div><h2 className="h2">{p.help_heading}</h2><p className="text-slate-600 mt-5 leading-relaxed">{p.help_body}</p><Link to="/register" className="btn-coral mt-8">See More</Link></div>
      </div></section>

      <section className="container-x py-16 lg:py-24">
        <h2 className="h2 text-center mb-10">{p.plans_heading}</h2>
        <div className="grid md:grid-cols-3 gap-5">{plans.map((pl) => (
          <div key={pl.id} className="card p-7 flex flex-col" data-testid={`about-plan-${pl.id}`}>
            <div className="text-3xl font-extrabold font-display">{gbp(pl.monthly_price)}<span className="text-sm font-normal muted">/month</span></div>
            <h3 className="text-lg font-bold mt-2">{pl.name} Plan</h3>
            <ul className="space-y-2 mt-5 flex-1">{pl.features.map((f) => <li key={f} className="flex gap-2 text-sm"><Check size={16} className="text-emerald-600 shrink-0" />{f}</li>)}</ul>
            <Link to="/pricing" className="btn-navy mt-6">Choose plan</Link>
          </div>))}</div>
      </section>

      <section className="container-x pb-8"><div className="rounded-3xl bg-[#FAF7EE] p-8 sm:p-12 grid lg:grid-cols-[1fr_auto] gap-8 items-center">
        <div><h2 className="h2">{p.cta_heading}</h2><p className="text-slate-600 mt-3">{p.cta_body}</p><Link to="/search" className="btn-coral mt-6" data-testid="about-find-pro-btn">Find a Professional</Link></div>
        <img src="/brand/h16.webp" alt="" className="w-full max-w-xs" loading="lazy" />
      </div></section>
    </div>
  );
}
